import request from './request'

export function listSourceCost(data) {
  return request.post('/mes/source-costs/list', data)
}
export function selectSourceCost() {
  return request.get('/mes/source-costs/select')
}
export function getSourceCost(id) {
  return request.get('/mes/source-costs/' + id)
}
export function saveSourceCost(data) {
  return request.post('/mes/source-costs', data)
}
export function updateSourceCost(data) {
  return request.post('/mes/source-costs/update', data)
}
export function deleteSourceCost(ids) {
  return request.post('/mes/source-costs/delete', ids)
}
